import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'
import { sportIds, leagueIds, teamIds } from 'src/constants/personalizationIds'

export default (props) => {
  // VideoObject structured data
  const videoStructuredData = createVideoStructuredData({
    networkName: 'SportsNet Pittsburgh',
    callsign: 'ATTPTHD',
    logoUrl: networkLogos.sportsnetpittsburgh.logoUrl,
    slug: 'sportsnet-pittsburgh',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="ATTPTHD"
        title="Watch SportsNet Pittsburgh live with Fubo"
        networkName="SportsNet Pittsburgh"
        sportId={sportIds.Baseball}
        leagueId={leagueIds.MLB}
        teamId={teamIds['Pittsburgh Pirates']}
      />
    </>
  )
}
